import React from "react";

import BackgroundWave from "../Vectors/img/loginWave.webp";

const LoginWave = () => {
  const gradientStyle = {
    position: "fixed",
    bottom: 0,
    zIndex: -1,
    width: "100%",
    height: "100%",
    backgroundImage: `url(${BackgroundWave})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    //backgroundSize : '100% 100%'
  };

  return (
    <React.Fragment>
      <div style={gradientStyle} />
    </React.Fragment>
  );
};

export default LoginWave;
